import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=01a16c2b&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&id=01a16c2b&prod&lang=scss&"
import style1 from "./preview.vue?vue&type=style&index=1&id=01a16c2b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports